import * as angular from 'angular';
import * as _ from 'lodash';

import { ITreeItem, Category, Dashboard, ComponentDefinition, Pattern } from '../../models';
import { IstateDependencyService, IStoreService, IUserSettingsService } from '../../services';
import { navigationHistoryUpdated, treePinned, treeUpdated } from '../../common';
import { StoreElement } from '../../stateManagement';
import { buildDashboardsTree } from './buildDashboardsTree';

class NavigationTreeController implements angular.IComponentController {
    categories: Category[] = [];
    dashboards: Dashboard[] = [];
    isLoading: boolean;
    isPinned = false;
    items: ITreeItem[];
    searchCriteria: Pattern<any>[];
    searchPlaceholder: string;
    state: angular.ui.IState;
    url: string;
    urlParams: any;

    private _garbages: (() => void)[] = [];

    static $inject = [
        '$scope',
        '$rootScope',
        'stateDependencyService',
        'storeService',
        'userSettingsService'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _$rootScope: angular.IRootScopeService,
        private _stateDependencyService: IstateDependencyService,
        private _storeService: IStoreService,
        private _userSettingsService: IUserSettingsService) {
    }

    $onInit() {
        this._garbages.push(this._$scope.$watch(() => this.state, () => {
            this.refreshTree();
        }));

        this._garbages.push(this._$scope.$on(treeUpdated, () => {
            this.refreshTree();
        }));

        if (this._userSettingsService.getSettingValue('treePinned') === 'true') {
            this.isPinned = true;
        }

        this._garbages.push(this._$rootScope.$on(navigationHistoryUpdated, () => {
            if (this.state && this.state.name === 'home') {
                this.refreshTree();
            }
        }));

        // Connect to REDUX
        this._garbages.push(this._storeService.register(store => {
            this.categories = _.values(store.categories.dictionary);
            this.dashboards = _.values(store.dashboards.dictionary);
            if (this.state && this.state.name === 'dashboards' && store.dashboards.isLoaded && store.categories.isLoaded) {
                const configuration = buildDashboardsTree(this.state.data.subMenu.subState, this.categories, this.dashboards);
                this.items = configuration.items;
                this.url = configuration.url;
                this.urlParams = configuration.urlParams;
                this.refreshTree();
            }
        }, [StoreElement.Categories, StoreElement.Dashboards, StoreElement.Groups]));
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['state'] && changesObj['state'].currentValue) {
            this.refreshTree();
        }
    }

    $onDestroy() {
        try {
            this._garbages.forEach(g => g());
        } catch (e) {
            console.error(e);
        }
    }

    private buildTree() {
        if (this.dashboards && this.dashboards.length) {
            const configuration = buildDashboardsTree(this.state.data.subMenu.subState, this.categories, this.dashboards);
            this.items = configuration.items;
            this.url = configuration.url;
            this.urlParams = configuration.urlParams;
        }
        // }
    }

    refreshTree() {
        if (this.state && this.state.data && this.state.data.subMenu) {
            if (this.state.name === 'dashboards') {
                this.buildTree();
            } else {
                this.isLoading = true;
                this._stateDependencyService
                    .getItems(this.state)
                    .then(configuration => {
                        configuration.items.forEach(item => {
                            item.uniqueId = item.guid;
                        });
                        this.items = configuration.items;
                        this.searchCriteria = configuration.searchCriteria;
                        this.searchPlaceholder = configuration.searchPlaceholder;
                        this.url = configuration.url;
                        this.urlParams = configuration.urlParams;
                    })
                    .finally(() => this.isLoading = false);
            }
        } else {
            this.items = [];
        }
    }

    toggleTree() {
        this.isPinned = !this.isPinned;
        this._$rootScope.$broadcast(treePinned, this.isPinned);
    }
}

export const wtNavigationTree: ComponentDefinition = {
    componentId: 'wtNavigationTree',
    controller: NavigationTreeController,
    template: require('./navigationTree.component.html'),
    controllerAs: 'vm',
    bindings: {
        state: '=',
        isMobileMode: '<?',
        onLinkClick: '&?'
    }
};